module.exports = __webpack_public_path__ + "img/borderLeftTriangleWhite.866e392b.svg";